import axios from "axios";
import coments from "../../models/autorizacion/coments";
import concepts from "../../models/autorizacion/concepts";
import costCenters from "../../models/autorizacion/costCenter";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getRolesComents(rol) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/rolescoments/${rol.id}`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return coments.fromJson(item);
        });
      });
  }

  getRolesConcepts(rol) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/rolesconceptos/${rol.id}`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return concepts.fromJson(item);
        });
      });
  }

  getRolesCostCenters(rol) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/rolescscosto/${rol.id}`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return costCenters.fromJson(item);
        });
      });
  }

  addRolesComment(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload;

    payload = {
      rolId: data.rolId,
      coments: data.idsComents,
    };

    return axios.post(`${url}/rolescoments`, payload, { headers });
  }

  addRolesConcepts(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload;

    payload = {
      rolId: data.rolId,
      conceptos: data.idsConcepts,
    };

    return axios.post(`${url}/rolesconceptos`, payload, { headers });
  }

  addRolesCostCenters(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload;

    payload = {
      rolId: data.rolId,
      csCostos: data.idsCostCenters,
    };

    return axios.post(`${url}/rolescscosto`, payload, { headers });
  }

  deleteRolesComent = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(`${url}/rolescoments/${data.rolId}&${data.id}`, {
      headers,
    });
  };

  deleteRolesConcept = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(`${url}/rolesconceptos/${data.rolId}&${data.id}`, {
      headers,
    });
  };

  deleteRolesCostCenter = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(`${url}/rolescscosto/${data.rolId}&${data.id}`, {
      headers,
    });
  };
}
export default service;
